//时间 (时间戳,是否精确到小时分钟，默认日期)
function getTimeText(date, ifSetTime = false) {
  if (date === "") return "";
  let time = date ? new Date(date) : new Date();
  let year = time.getFullYear();
  let month =
    time.getMonth() - 0 + 1 > 9
      ? time.getMonth() - 0 + 1
      : "0" + (time.getMonth() - 0 + 1);
  let day = time.getDate() > 9 ? time.getDate() : "0" + time.getDate();
  if (ifSetTime) {
    let hour = time.getHours() > 9 ? time.getHours() : "0" + time.getHours();
    let minutes =
      time.getMinutes() > 9 ? time.getMinutes() : "0" + time.getMinutes();
    let seconds =
      time.getSeconds() > 9 ? time.getSeconds() : "0" + time.getSeconds();
    return (
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hour +
      ":" +
      minutes +
      ":" +
      seconds
    );
  }
  return year + "-" + month + "-" + day;
}
//设备检测
function isMobile(name) {
  if (/android/i.test(navigator.userAgent)) {
    //这是Android平台下浏览器
    return name == "ios" ? false : true;
  } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //这是iOS平台下浏览器、
    return name == "android" ? false : true;
  }
  return false;
}
//查询字符串 字符串 查找的字符 第几个
function getStrPosition(str, word, i) {
  let position1 = 0;
  let position2 = 0;
  for (let no = 0; no < i; no++) {
    position1 = str.indexOf(word);
    if (no == i - 1) {
      break;
    }
    str =
      str.substring(0, str.indexOf(word)) +
      str.substr(str.indexOf(word) + word.length);
    position2 += word.length;
  }
  return position1 + position2;
}
function getPara(key) {
  let value = "";
  let paraText = window.location.href.split("?")[1];
  if (paraText) {
    let paraList = paraText.split("&");
    paraList.some((item) => {
      let itemList = item.split("=");
      if (itemList[0] == key) {
        value = itemList[1];
        return true;
      }
    });
  }
  return value;
}
function searchList() {
  let para = {};
  let paraText = window.location.href.split("?")[1];
  if (paraText) {
    let paraList = paraText.split("&");
    paraList.forEach((item) => {
      let itemList = item.split("=");
      para[itemList[0]] = itemList[1];
    });
  }
  return para;
}
//浏览器及版本检测
function checkBrowserVersion() {
  const userAgent = navigator.userAgent;
  let browserMatch = userAgent.match(/(chrome|firefox|edg|360se)\/(\d+)/i);
  // 如果没有匹配到上述浏览器，则可能不是目标浏览器
  if (!browserMatch) {
    return false;
  }

  let browserName = browserMatch[1].toLowerCase();
  let browserVersion = parseInt(browserMatch[2], 10);

  // 根据浏览器名称设置最小版本号
  let minVersion;
  switch (browserName) {
    case "chrome":
      minVersion = 60;
      break;
    case "firefox":
      minVersion = 60;
      break;
    case "edg":
      minVersion = 91;
      break;
    case "360se":
      return true;
    default:
      return false;
  }

  // 检查版本是否满足要求
  if (browserVersion >= minVersion) {
    return true;
  } else {
    return false;
  }
}

export {
  getTimeText,
  isMobile,
  getStrPosition,
  getPara,
  searchList,
  checkBrowserVersion,
};
